<sw-modal
    :title="modalTitle"
    @modal-close="onCancel"
>
    <sw-text-field
        v-model:value="entity.word"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.labelWord')"
        :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.placeholderWord')"
    ></sw-text-field>

    <sw-single-select
        v-model:value="entity.languageId"
        required
        :options="languageOptions"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnLanguage')"
    ></sw-single-select>

    <sw-switch-field
        v-model:value="entity.active"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.columnActive')"
    ></sw-switch-field>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>
